import type { ToolCallMessagePartProps } from "@assistant-ui/react";
import { toolFallbackStyles as s } from "./ToolFallback.styles";

export function ToolFallback({ toolName, argsText, result }: ToolCallMessagePartProps) {
  return (
    <div className={s.root}>
      <div className={s.header}>🔧 {toolName}</div>
      {argsText && <pre className={s.args}>{argsText}</pre>}
      {result !== undefined && (
        <pre className={s.result}>
          {typeof result === "string" ? result : JSON.stringify(result, null, 2)}
        </pre>
      )}
    </div>
  );
}
